export default "__VITE_ASSET__c320d9be__"